export default __webpack_public_path__ + "static/media/Jost-SemiBold.ec58ba95.ttf";